export const riaaCerts = [
	{
		artist: 'Eminem',
		item: 'Bad Guy',
		type: 'Song',
		year: 2022,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682608701/srbeats_photos/m0khrujkzfuuyvtqyooi.jpg',
	},
	{
		artist: 'Wale',
		item: `Wow... That's Crazy`,
		type: 'Album',
		year: 2021,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682620920/srbeats_photos/zdlsfqrqsvgfrhmzoaat.jpg',
	},
	{
		artist: 'H.E.R.',
		item: `Back of My Mind`,
		type: 'Album',
		year: 2021,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682612072/srbeats_photos/ymn1rwrl3yrslr4bsvqv.jpg',
	},
	{
		artist: 'DJ Khaled',
		item: `Khaled Khaled`,
		type: 'Album',
		year: 2021,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682608073/srbeats_photos/mhajcbqdcr6tfk1jvqmp.jpg',
	},
	{
		artist: 'DJ Khaled',
		item: 'Higher (feat. Nipsey Hustle, John Legend',
		type: 'Song',
		year: 2020,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682607774/srbeats_photos/ft6erxflgibxw2u2ef0v.jpg',
	},
	{
		artist: 'DJ Khaled',
		item: `Father of Asahd`,
		type: 'Album',
		year: 2019,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682607774/srbeats_photos/ft6erxflgibxw2u2ef0v.jpg',
	},
	{
		artist: 'Meek Mill',
		item: `What's Free (feat. Rick Ross, Jay-Z)`,
		type: 'Song',
		year: 2019,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682618455/srbeats_photos/bi6er1llnzmus0lhwrs1.jpg',
	},
	{
		artist: 'Meek Mill',
		item: `Championships`,
		type: 'Album',
		year: 2019,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682618455/srbeats_photos/bi6er1llnzmus0lhwrs1.jpg',
	},
	{
		artist: 'Meek Mill',
		item: `Wins and Losses`,
		type: 'Album',
		year: 2018,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682618309/srbeats_photos/iescymlhoile08n85l9e.jpg',
	},
	{
		artist: 'DJ Khaled',
		item: `Grateful`,
		type: 'Album',
		year: 2019,
		award: '2x Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682607689/srbeats_photos/r2rebpeud20et6hn2gez.jpg',
	},
	{
		artist: 'Lil Dicky',
		item: `Molly`,
		type: 'Song',
		year: 2015,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682615668/srbeats_photos/mdd4vyt5c7fqukkbhy12.jpg',
	},
	{
		artist: 'Lil Dicky',
		item: `Professional Rapper`,
		type: 'Album',
		year: 2015,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682615668/srbeats_photos/mdd4vyt5c7fqukkbhy12.jpg',
	},
	{
		artist: 'Rick Ross',
		item: `Mastermind`,
		type: 'Album',
		year: 2014,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682618959/srbeats_photos/ufbht06ve3tn25h2cckv.jpg',
	},
	{
		artist: 'Eminem',
		item: `Marshall Mathers LP 2`,
		type: 'Album',
		year: 2017,
		award: '4x Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682608701/srbeats_photos/m0khrujkzfuuyvtqyooi.jpg',
	},
	{
		artist: 'Lil Wayne',
		item: `I Am Not a Human Being II`,
		type: 'Album',
		year: 2013,
		award: '2x Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682616654/srbeats_photos/zd7wbta8ufpjrmxxaeb1.jpg',
	},
	{
		artist: '2 Chainz',
		item: `Based On a T.R.U. Story`,
		type: 'Album',
		year: 2012,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682487594/srbeats_photos/qozdz5zn7xnrl7jso4vn.jpg',
	},
	{
		artist: 'Lil Wayne',
		item: `My Homies Still (feat. Big Sean)`,
		type: 'Song',
		year: 2012,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682616654/srbeats_photos/zd7wbta8ufpjrmxxaeb1.jpg',
	},
	{
		artist: 'Lil Wayne',
		item: `The Carter IV`,
		type: 'Album',
		year: 2012,
		award: '5x Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682616523/srbeats_photos/yyznaxzyjlny5iso3spl.jpg',
	},
	{
		artist: 'Lil Wayne',
		item: `I Am Not a Human Being`,
		type: 'Album',
		year: 2010,
		award: '2x Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682616265/srbeats_photos/jmmex9y5irmmwl44csg6.jpg',
	},
	{
		artist: 'Lil Wayne',
		item: `Rebirth`,
		type: 'Album',
		year: 2010,
		award: 'Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682616364/srbeats_photos/egom5xy4nifwz0k8hcpx.jpg',
	},
	{
		artist: 'Ludacris',
		item: `Theater of the Mind`,
		type: 'Album',
		year: 2008,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682617788/srbeats_photos/ldfpy4ikafw4ztzzveqc.jpg',
	},
	{
		artist: 'Lil Wayne',
		item: `The Carter III`,
		type: 'Album',
		year: 2008,
		award: '6x Platinum',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682616218/srbeats_photos/jmkanhz3gjk09udhaxvu.jpg',
	},
	{
		artist: 'Juelz Santana',
		item: `What the Game's Been Missing!`,
		type: 'Album',
		year: 2005,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682615533/srbeats_photos/wgi3ndphxs92oiyu7hxn.jpg',
	},
	{
		artist: 'Terror Squad',
		item: `True Story`,
		type: 'Album',
		year: 2004,
		award: 'Gold',
		img: 'https://res.cloudinary.com/dcbkcdxat/image/upload/v1682620339/srbeats_photos/ulkw2haynsqagw6epqdx.jpg',
	},
];
